import { Component } from '@angular/core';
import { ToastService } from './toast.service';

@Component({
  selector: 'app-toasts',
  templateUrl: './toasts-container.component.html',
  styleUrls: ['./toasts-container.component.scss'],
  standalone: false,
})
export class ToastsContainerComponent {
  constructor(public toastService: ToastService) {}
}
